module.exports = __webpack_public_path__ + "static/media/live-attenuated-virus.a5ef62ff.jpg";